import http from "../../http";

/**
 * 全员营销接口
 */
export default {
  // 分享日志详情
  shareLog: (params) => {
    return http.post("marketcenter/share/log/detail", params);
  },
  // 活动分享排名（组织）
  activeShareRankingOrg: (params) => {
    return http.post("marketcenter/share/rank?aid=" + params.aid, params);
  },
  // 活动分享排名（个人）
  activeShareRankingPerson: (params) => {
    return http.post("marketcenter/share/person/rank", params);
  },
  // 导出分享日志Excel（函数版本）
  exportShareLogExcel: (params) => {
    return http.get("marketcenter/share/log/", params);
  },
  // 导出分享日志Excel URL（用于 window.open 下载）
  exportShareLogExcelUrl: "marketcenter/share/log/",
  // 导出分享日志
  exportShareLog: (params) => {
    return http.post("marketcenter/share/log/excel", params);
  },
};
